
import './dateInput.scss';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { RangeOptions } from './dateInput';


type DateInputFooterProps = {
  validationMessage?: string;
  options?: RangeOptions[];
  value?: [Dayjs, Dayjs] | Dayjs;
  activeRangeOption?: RangeOptions;
  isRangePicker?: boolean;
  setActiveRange?: (activeRange: RangeOptions) => void;
  onApply?: () => void;
  handleChange?: (dates: [Dayjs | null, Dayjs | null] | Dayjs | null, dateStrings: [string, string] | string | null) => void;
  cancel?: () => void;
  apply?: () => void;
}

export const DateInputFooter = ({ cancel, apply, validationMessage, options, value, activeRangeOption, onApply, setActiveRange, isRangePicker }: DateInputFooterProps) => {

  const setRange = (option: RangeOptions) => {
    if (setActiveRange) setActiveRange(option);
  }

  const applyHanlder = () => {
    if (apply) apply();
    if (onApply) onApply()
  }

  return (
    <div className="datepicker-footer">
      <div className="select-period">
        {isRangePicker && options && options?.length > 0 && options.map((option: RangeOptions) =>
          <button
            className={`${option.name === activeRangeOption?.name ? 'active' : ''} period`}
            key={option.name}
            onClick={() => setRange(option)}>
            {option.name}
          </button>
        )}
      </div>

      <div className="confirmation">

        {validationMessage &&
          <span className="message">
            {validationMessage}
          </span>}

        <div className="buttons">
          {isRangePicker && value &&
            <div className="range">
              {`${dayjs((value as [Dayjs, Dayjs])[0]).format('DD/MM/YYYY')}-${dayjs((value as [Dayjs, Dayjs])[1]).format('DD/MM/YYYY')}`}
            </div>}

          <button className="cancel" onClick={cancel}>Cancel</button>
          <button className="apply" onClick={applyHanlder}>Apply</button>
        </div>

      </div>
    </div>
  )
}